import { useEffect } from "react";

import { track } from "../analytics";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { Nav } from "../components/Nav";
import { useSmoothScroll } from "../hooks/useSmoothScroll";

/**
 * Dedicated /contact page — the Satsangh invitation with room of its
 * own, one click from any page via the menu. The home page keeps the
 * same content as its closing chapter.
 */
export function ContactPage() {
  useSmoothScroll();

  useEffect(() => {
    track("contact_page_viewed");
  }, []);

  return (
    <>
      <Nav />
      <main className="bg-cream">
        <Contact standalone />
      </main>
      <Footer />
    </>
  );
}
